import { app } from '../../../../../app';

app.service('AddNewSharedNoteModal', modal);

/** @ngInject */
function modal($uibModal) {
    return () => $uibModal.open({
        component: 'companySharingCenterSharedNotesAdd',
       // resolve: {publicServices: () => publicServices},
    }).result
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-notes/add/add-shared-note.modal.js